import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '../types';
import {
	IdentificationInfo,
	PersonalInfo,
	ParentInfo,
	AddressInfo,
	ContactInfo,
	SchoolInfo,
	DocumentInfo,
	Answer
} from '@/types';
import { StudentOption } from '@/services/ei/student/types';

export interface RegisterState {
	informationBool: boolean;
	identificationInfo: IdentificationInfo;
	documentInfo: DocumentInfo;
	answers: Answer[];
}

const getDefaultState = (): RegisterState => {
	return {
		informationBool: false,
		identificationInfo: {
			personalInfo: {},
			parentInfo: {},
			schoolInfo: {},
			contactInfo: {},
			addressInfo: {}
		},
		documentInfo: {
			optionalAttachments: [],
			requiredAttachments: [],
			bankAttachments: []
		},
		answers: []
	};
};

const state = getDefaultState();

const actions: ActionTree<RegisterState, RootState> = {
	updateInformationBool({ commit }, info: boolean) {
		commit('UPDATE_INFORMATIONBOOL', info);
	},
	updateIdentificationInfo({ commit }, info: IdentificationInfo) {
		commit('UPDATE_IDENTIFICATIONINFO', info);
	},
	updatePersonalInfo({ commit }, info: PersonalInfo) {
		commit('UPDATE_PERSONALINFO', info);
	},
	updateSchoolInfo({ commit }, info: SchoolInfo) {
		commit('UPDATE_SCHOOLINFO', info);
	},
	updateParentInfo({ commit }, info: ParentInfo) {
		commit('UPDATE_PARENTINFO', info);
	},
	updateAddressInfo({ commit }, info: AddressInfo) {
		commit('UPDATE_ADDRESSINFO', info);
	},
	updateContactInfo({ commit }, info: ContactInfo) {
		commit('UPDATE_CONTACTINFO', info);
	},
	updateDocumentInfo({ commit }, info: DocumentInfo) {
		commit('UPDATE_DOCUMENTINFO', info);
	},
	updateAnswers({ commit }, answers: Answer[]) {
		commit('UPDATE_ANSWERS', answers);
	},
	updateStudentInfo({ commit }, studentInfo: StudentOption) {
		commit('UPDATE_ADDRESSINFO', studentInfo.address);
		commit('UPDATE_PERSONALINFO', studentInfo);
		commit('UPDATE_SCHOOLINFO', studentInfo);
		commit('UPDATE_CONTACTINFO', studentInfo);
		commit('UPDATE_PARENTINFO', studentInfo);
	},
	clearStore({ commit }) {
		commit('CLEAR_STORE');
	}
};

const mutations: MutationTree<RegisterState> = {
	UPDATE_INFORMATIONBOOL(state, info: boolean) {
		state.informationBool = info;
	},
	UPDATE_IDENTIFICATIONINFO(state, info: IdentificationInfo) {
		state.identificationInfo = info;
	},
	UPDATE_PERSONALINFO(state, info: PersonalInfo) {
		state.identificationInfo.personalInfo = info;
	},
	UPDATE_SCHOOLINFO(state, info: SchoolInfo) {
		state.identificationInfo.schoolInfo = info;
	},
	UPDATE_PARENTINFO(state, info: ParentInfo) {
		state.identificationInfo.parentInfo = info;
	},
	UPDATE_ADDRESSINFO(state, info: AddressInfo) {
		state.identificationInfo.addressInfo = info;
	},
	UPDATE_CONTACTINFO(state, info: ContactInfo) {
		state.identificationInfo.contactInfo = info;
	},
	UPDATE_DOCUMENTINFO(state, info: DocumentInfo) {
		state.documentInfo = structuredClone(info);
	},
	UPDATE_ANSWERS(state, answers: Answer[]) {
		state.answers = answers;
	},
	CLEAR_STORE(state) {
		Object.assign(state, getDefaultState());
	}
};

const getters: GetterTree<RegisterState, RootState> = {};

const appSate: Module<RegisterState, RootState> = {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};

export default appSate;
